import React from 'react';
import { Box, Typography } from '@mui/material';
import RodapeImgs from '../imgs/rodape-imgs.png';

export default function Footer() {
  return (
    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }} component="footer" textAlign="center" py={2} mt={5} bgcolor="#f5f5f5">
      <img src={RodapeImgs} alt="Imagens do rodapé" style={{ maxWidth: 200 }} />
      <Typography style={{ textAlign: 'center' }} variant="body2">&copy; {new Date().getFullYear()} InfoSaúde e Adolescentes. Todos os direitos reservados.</Typography>
    </Box>
  );
}